import React from 'react'
import Checkout from '../components/checkout'

const PricingTable = ({
  toggleSignUpModal
}) => (
  <div className='Pricing'>

    <div className='Pricing__header'>
      <span className='Pricing__title'>One Time Special</span>
      <span className='Pricing__price'>
        $25
        {/* <span className='Pricing__price-time'>one time</span> */}
      </span>
    </div>

    <ul className='Pricing__features' style={{
      paddingLeft: '0px',
    }}>
    <li style={{listStyle:'none',}}>Once off charge</li>
    <li style={{listStyle:'none',}}>Access to all existing articles</li>
    <li style={{listStyle:'none',}}>Access to all new articles that will be introduce in 2019</li>
    </ul>

    <div className='Pricing__footer'>   
        <div>
            <Checkout />
          <div className='Pricing__meta'>
            Prices in SGD
          </div>
        </div>
     
    </div>

    <style jsx>{`
      .Pricing {
        border-radius: 6px;
        background-color: #ffffff;
        box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
        border: solid 1px rgba(11, 15, 21, 0.05);
        padding: 25px 30px;
        position: relative;
        width: 370px;
      }
      @media screen and (max-width: 400px) {
        .HiddenAtSm {
          display: none;
        }
      }
      @media screen and (min-width: 400px) {
        .Pricing {
          padding: 40px 50px;
        }
      }
      .Pricing__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .Pricing__title {
        font-size: 24px;
        color: #7a7f87;
        vertical-align: middle;
      }
      .Pricing__price {
        font-size: 48px;
        font-weight: bold;
        color: #0b0d11;
        vertical-align: middle;
      }
      .Pricing__price-time {
        font-size: 24px;
        font-weight: normal;
      }
      .Pricing__features {
        list-style: none;
        font-size: 18px;
        color: #0b0d11;
        margin-top: 30px;
      }
      .Pricing__features li::before {
        content: '\\f00c';
        margin-right: 10px;
        font-family: FontAwesome;
        font-size: 14px;
        color: #2c59c5;
      }
      .Pricing__features li + li {
        margin-top: 16px;
      }
      .Pricing__footer {
        margin-top: 40px;
        text-align: center;
      }
      .Pricing__meta {
        margin-top: 20px;
        font-size: 14px;
        color: #7a7f87;
      }
    `}</style>
  </div>
)

export default PricingTable


// WEBPACK FOOTER //
// ./src/components/PricingTable.jsx